function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as constants from '../../../constants';
import messages from '../../../messages';
import validatorRules from './validatorRules.json';
class PasswordForm extends FormContainerAbstract {
    renderCancelBtn() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-12 col-sm-6",
            children: /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: App.messages.buttons.cancel,
                className: "btn--block",
                isDisabled: this.props.isInProgress,
                onClick: this.props.onCancel
            })
        });
    }
    renderSubmitBtn() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-12 col-sm-6",
            children: /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                styleModifier: "primary",
                labelMessage: messages.buttons.switchIdentity,
                className: "btn--block btn--filled",
                isDisabled: this.isDisabled,
                isInProgress: this.props.isInProgress
            })
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row flex-column-reverse flex-sm-row",
            children: [
                this.renderCancelBtn(),
                this.renderSubmitBtn()
            ]
        });
    }
    renderFields() {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx(FormGroup, {
                id: "password",
                labelMessage: messages.labels.password,
                formValues: this.props.formValues,
                children: /*#__PURE__*/ _jsx(Input, {
                    type: "password",
                    placeholder: messages.placeholders.password,
                    onChange: (input)=>this.onSetValue(input)
                })
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            className: "mt-8",
            onSubmit: ()=>this.onSubmit(),
            children: [
                this.renderFields(),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
    }
}
_define_property(PasswordForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    onCancel: PropTypes.func.isRequired
}));
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.IDENTITY_PASSWORD_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.IDENTITY_PASSWORD_FORM;
    return {
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedPasswordForm = connect(mapStateToProps, mapDispatchToProps)(PasswordForm);
export default ConnectedPasswordForm;
